import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./mobile_style.less?vue&type=style&index=0&id=7132d9b2&lang=less&scoped=true"
import "./pc_style.less?vue&type=style&index=1&id=7132d9b2&lang=less&scoped=true"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7132d9b2"]])

export default __exports__